var React = require('react');

function CheckMini (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.91792 1.8637L3.94986 7.38104L1.19109 4.89725","stroke":"#2B38BD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckMini.defaultProps = {"width":"10","height":"9","viewBox":"0 0 10 9","fill":"none"};

module.exports = CheckMini;

CheckMini.default = CheckMini;
